import { createNamespacer, createReducer } from '../utils/reducers';

const initialState = {
  isLoading: 0,
  appDataLoading: false,
  showAdvanceSearch: false,
};

const namespacer = createNamespacer('APPEARANCE');

const handlers = {
  [`${namespacer('SET_LOADING')}`]: (state, action) => {
    // the increment and decrement logic is added to solve global loader disappearing when we set loader true multiple times (multiple components) but false once.
    // so now if we set it to true 2 times we need to set it as false 2 times to hide the loader
    let loadingVal = state.isLoading;
    if (action.payload.value) {
      loadingVal += 1;
    } else {
      loadingVal = loadingVal > 0 ? loadingVal - 1 : 0;
    }
    return {
      ...state,
      isLoading: loadingVal,
    };
  },
  [`${namespacer('SET_APP_DATA_LOADING')}`]: (state, action) => {
    return {
      ...state,
      appDataLoading: action.payload.value,
    };
  },
};

const appearanceReducer = createReducer(initialState, handlers, ['APPEARANCE']);

export default appearanceReducer;
